import $ from 'jquery';
window.$ = window.jQuery = $;

$('.modal__form--name').submit(function(e) {
  e.preventDefault();
  $('.modal__content--name').removeClass('active');
  $('.modal__success--name').addClass('active');
});

$('.modal__form--company').submit(function(e) {
  e.preventDefault();
  $('.modal__content--company').removeClass('active');
  $('.modal__success--company').addClass('active');
});